import { Link } from "@tanstack/react-router"
import { useQueryState, parseAsStringLiteral } from "nuqs"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@aix/ui"
import DebugTab from "./DebugTab"
import TrackablesListTab from "./TrackablesListTab"
import CalendarTab from "./CalendarTab"
import BrainDumpsTab from "./BrainDumpsTab"

type TabValue = "debug" | "trackables" | "calendar" | "brain-dumps"

export default function TrackablesScreen() {
  const [activeTab, setActiveTab] = useQueryState(
    "tab",
    parseAsStringLiteral(["debug", "trackables", "calendar", "brain-dumps"]).withDefault("debug"),
  )

  const handleTabChange = (value: string) => {
    void setActiveTab(value as TabValue, { history: "push" })
  }

  return (
    <div className="h-full flex flex-col bg-background">
      {/* Header */}
      <div className="border-b-4 border-border bg-secondary p-6">
        <div className="flex items-center gap-2">
          <h1 className="text-3xl font-bold text-primary">Trackables Admin</h1>
          <Link
            to="/coach-os"
            className="text-sm text-muted-foreground hover:text-primary transition-colors border border-border px-2 py-1 rounded hover:border-primary"
          >
            → CoachOS
          </Link>
        </div>
        <p className="text-sm text-muted-foreground mt-2">Manage trackables, view entries, and debug data</p>
      </div>

      {/* Tabs */}
      <div className="flex-1 overflow-hidden">
        <Tabs value={activeTab} onValueChange={handleTabChange} className="h-full flex flex-col">
          <div className="border-b-2 border-border bg-background px-6">
            <TabsList className="bg-transparent">
              <TabsTrigger
                value="debug"
                className="border-2 border-border data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
              >
                🐛 Debug
              </TabsTrigger>
              <TabsTrigger
                value="trackables"
                className="border-2 border-border data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
              >
                📋 Trackables List
              </TabsTrigger>
              <TabsTrigger
                value="calendar"
                className="border-2 border-border data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
              >
                📅 Calendar/Entries
              </TabsTrigger>
              <TabsTrigger
                value="brain-dumps"
                className="border-2 border-border data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
              >
                🧠 Brain Dumps
              </TabsTrigger>
            </TabsList>
          </div>

          <div className="flex-1 overflow-auto">
            <TabsContent value="debug" className="h-full m-0">
              <DebugTab />
            </TabsContent>
            <TabsContent value="trackables" className="h-full m-0">
              <TrackablesListTab />
            </TabsContent>
            <TabsContent value="calendar" className="h-full m-0">
              <CalendarTab />
            </TabsContent>
            <TabsContent value="brain-dumps" className="h-full m-0">
              <BrainDumpsTab />
            </TabsContent>
          </div>
        </Tabs>
      </div>
    </div>
  )
}
